/** Tuning for avatar emotion overlay transitions and Core talking attenuation. */
const avatarEmotionConfig = {
  /** Higher values crossfade emotion targets faster (blendShapeRamp → target map, meshLerp → rig). */
  transitionSpeed: {
    blendShapeRamp: {
      core: 10,
      convai: 10,
      whileTalking: 10
    },
    meshLerp: {
      idle: 24,
      whileTalking: 18
    }
  },
  /** Scales Core preset weights while viseme15 lipsync drives the mouth. */
  coreTalkingScale: {
    upperFace: 0.92,
    mouth: 0.78
  }
};

export default avatarEmotionConfig;
